module.exports = __webpack_public_path__ + "static/media/duration.610d0af5.png";